import {
  EmptyStateBellRing,
  EmptyStateHands,
  EmptyStateBells,
  EmptyStateDevice,
} from "@components/svgs";

export const newsImages = [EmptyStateBellRing, EmptyStateHands, EmptyStateBells, EmptyStateDevice];

export const newsTexts = [
  {
    title: "Ótimo! Você verificou todas as novidades!",
    subtitle: "Você se atualizou de tudo o que aconteceu nos seus processos e casos.",
  },
  {
    title: "Excelente trabalho! Todas as novidades foram verificadas!",
    subtitle: "Você está a par do andamento dos seus processos e casos.",
  },
  {
    title: "Parabéns! Você conferiu tudo por aqui!",
    subtitle: "Nós vamos avisar sempre que houver algo novo.",
  },
  {
    title: "Você é uma pessoa atualizada!",
    subtitle: "Muito bom! Você conferiu tudo o que precisava.",
  },
];
